export const NOTIFICATION_TYPES = {
	promotion: 'FREE_PROMOTION',
	decisionMakerRecommendation: 'DECISION_MAKER_RECOMMENDATION',
	autoTaggedPetition: 'AUTO_TAGGED_PETITION',
	emailDecisionMaker: 'EMAIL_DECISION_MAKER',
	freePromotionFulfillment: 'FREE_PROMOTION_FULFILLMENT',
} as const;
